import { render } from "./EditPharmaceuticalItem.vue?vue&type=template&id=d46c801c"
import script from "./EditPharmaceuticalItem.vue?vue&type=script&lang=js"
export * from "./EditPharmaceuticalItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__